<script>
import { mapActions, mapState } from 'vuex'

import ApiDropdown from './ApiDropdown.vue'
import ApiTable from './api-tables/ApiTable.vue'
import ButtonExtender from './button-extender.vue'
import ButtonLab from './button-lab.vue'
import ButtonRdpFullscreen from './button-rdp-fullscreen.vue'
import ButtonRdpRefresh from './button-rdp-refresh.vue'
import ButtonSave from './button-save.vue'
import ButtonTopology from './button-topology.vue'
import ButtonTopologyClone from './button-topology-clone.vue'
import ButtonTopologyShare from './button-topology-share.vue'
import ButtonTopologyEdit from './button-topology-edit.vue'
import ButtonTopologyDelete from './button-topology-delete.vue'
import ProgressBar from './progress-bar.vue'
import RadialProgress from './radial-progress.vue'
import Reservation from './reservation.vue'
import ReservationRdpControls from './reservation-rdp-controls.vue'
import ReservationRdpStatus from './reservation-rdp-status.vue'
import ReservationVmControls from './reservation-vm-controls.vue'
import TopologyEditor from './topology-editor.vue'
import TopologyVerticalDiagram from './topology/TopologyVerticalDiagram.vue'
import TopologyHorizontalDiagram from './topology/TopologyHorizontalDiagram.vue'

export default {
  name: 'App',
  el: '#vue-labstack',

  components: {
    ApiDropdown,
    ApiTable,
    ButtonExtender,
    ButtonLab,
    ButtonRdpFullscreen,
    ButtonRdpRefresh,
    ButtonSave,
    ButtonTopology,
    ButtonTopologyClone,
    ButtonTopologyEdit,
    ButtonTopologyShare,
    ButtonTopologyDelete,
    ProgressBar,
    RadialProgress,
    Reservation,
    ReservationRdpControls,
    ReservationRdpStatus,
    ReservationVmControls,
    TopologyEditor,
    TopologyHorizontalDiagram,
    TopologyVerticalDiagram
  },

  created () {
    this.getCurrentReservation()
    this.startHandler()
  },

  destroyed () {
    this.stopHandler()
  },

  computed: {
    ...mapState({
      current: state => state.reservation.current,
      refreshInterval (state) {
        return state.reservation.current.refresh_interval
      },
      reservationTransaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      topologyBlueprints: state =>
        state.topology.topology_blueprints,
      is_terminating: state =>
        state.reservation.current.is_terminating
    }),

    topologyBlueprint: function () {
      if(! this.reservationTransaction) {
        return
      }

      let topologyBlueprintId = this.reservationTransaction
        .attributes
        .topology_blueprint_id

      return this.topologyBlueprints
        .find(
            t => t.id == topologyBlueprintId
        )
    },
  },

  methods: {
    ...mapActions([
      'getCurrentReservation'
    ]),

    /*
     * Start the server long polling interval.
     */
    startHandler: function () {
      this.handler = setInterval(() => {
        if(this.is_terminating) {
          return
        }

        this.getCurrentReservation()
      }, this.refreshInterval)
    },

    /*
     * Stop the server long polling interval.
     */
    stopHandler: function () {
      clearInterval(this.handler)
    },
  }
}
</script>
